import type React from 'react'
import { GripHorizontal } from 'lucide-react'
import { cn } from '@/utils'

interface ColorPopoverResizeGripProps {
  isResizing: boolean
  onPointerDown: (e: React.PointerEvent<HTMLButtonElement>) => void
  onPointerMove: (e: React.PointerEvent<HTMLButtonElement>) => void
  onPointerUp: (e: React.PointerEvent<HTMLButtonElement>) => void
  onPointerCancel: (e: React.PointerEvent<HTMLButtonElement>) => void
}

export function ColorPopoverResizeGrip({
  isResizing,
  onPointerDown,
  onPointerMove,
  onPointerUp,
  onPointerCancel,
}: ColorPopoverResizeGripProps) {
  return (
    <button
      type="button"
      aria-label="Resize color list"
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={onPointerUp}
      onPointerCancel={onPointerCancel}
      className={cn(
        'touch-none flex h-3 w-full cursor-ns-resize items-center justify-center border-none bg-transparent p-0 mt-1 text-muted-foreground hover:bg-black/[0.04]',
        isResizing && 'bg-black/[0.04]'
      )}
    >
      <GripHorizontal className="size-4" strokeWidth={2} aria-hidden="true" />
    </button>
  )
}
